import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/visitConstans';

const initialState = {
  visit: null,
  loading: true,
};

const visitReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VISIT:
      return {
        ...initialState,
      };
    case types.GET_VISIT_SUCCESS:
      return {
        ...state,
        loading: false,
        visit: payload,
      };
    case types.GET_VISIT_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VISIT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default visitReducer;
